import React from 'react';

import {Button} from '@albert-io/atomic';

import {ANNOTATION_SHIELD_EXEMPT_PROPS} from 'client/components/PracticeView/Annotations/annotationFreeze';

interface Props {
  onClick: () => void;
}

export default function SubmitAssignment({onClick}: Props) {
  return (
    <Button
      color='primary'
      data-testid='assignment-practice-view__submit-assignment-btn'
      onClick={onClick}
      {...ANNOTATION_SHIELD_EXEMPT_PROPS}
    >
      Submit Assignment
    </Button>
  );
}
